
import projImg1 from "../img/project-img1.png";
import projImg2 from "../img/project-img2.png";
import projImg3 from "../img/project-img3.png";
import Project_Portfilio from '../img/Project_Portfilio.png';
import Project_Portfilio_2 from '../img/Project_Portfilio_2.png';
import Project_Portfilio_3 from '../img/Project_Portfilio_3.png';
import Project_FS_2 from '../img/Project_FS_2.png'
import ProjectStack from '../img/ProjectFullStack3.png'
import ProjectStack2 from '../img/ed.png'
import ChatGpt from '../img/ChatGpt.png'
import MobileApp from '../img/Mobile App.png'
export const projects_FullStack = [
    {
      title: "Booking Web App",
      projectUrl: {github:'Booking-Web-App',Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697465384/Admin_Dashbord_b58fb0.mp4'},
      imgUrl: Project_Portfilio,
      description:{Title:'Booking App',
      Desc:
      'Develop a web app with a user-friendly front-end for hotel booking, including user registration and room availability. Create a secure admin panel for user, room, and hotel management. Ensure seamless user experience, robust back-end, and effective database design',
      TechUsed:'React js, Node js, express, mongodb'}
    },
    {
      title: "Ecomerce App",
      projectUrl: {github:'Booking-Web-App',Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697471993/Ecomerce.mp4'},
      imgUrl: Project_FS_2,
      description:{Title:'Ecomerce Web App',
      Desc:
     ' Build an e-commerce website offering tech products like phones and tablets, featuring Stripe integration for smooth client payments. Develop an admin dashboard for efficient user, order, and product management, as well as monthly sales charts.',
      TechUsed:'React js Node js express mongodb stripe materielle ui.' }
    },
    {
      title: "Blog App",
      projectUrl: {github:'Bloc-Application-with-server-side-rendering',Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697982283/BlogApp.webm'},
      imgUrl: ProjectStack,
      description:{Title:'Blog App',
      Desc:'A blog app allows users to create, publish, and manage their blogs. It utilizes server-side rendering techniques to deliver a seamless user experience. With this app, you can easily add new blog posts, fetch existing ones, update your content, and even delete outdated entries, making it a powerful tool for bloggers looking to streamline their content management process.',
      TechUsed:'Node Js, express js, ejs, mongodb'}
    },
    {
      title: "Food Ordering Delivery",
      projectUrl: {github:'Food-Delivery-Web-App',Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697544628/Screencast_from_16_%D8%A3%D9%83%D8%AA%D9%88%D8%A8%D8%B1_2023_CET_05_51_44_%D9%85_c2dki2.webm'},
      imgUrl: ProjectStack2,
      description:{Title:'Food Ordering Delivery',
      Desc:'Ordering food is a breeze with our app. Explore a variety of dishes, add them to your cart, and enjoy a hassle-free delivery to your doorstep.',
      TechUsed:'React js Node js express mongodb'}
    },
    {
      title: "ChatGpt Clone",
      projectUrl: {github:'ChatGpt-Clone',Deployment:'#'},
      imgUrl: ChatGpt,
      description:{Title:'ChatGpt Clone',
      Desc:'Developing a GPT-based chatbot clone with identical functionality, advanced prompting capabilities, and enhanced response generation."',
      TechUsed:' Node js, express , OpenIA Api , Vanilla script , vite'}
    },
  ];

  
  export const projects_Frontend = [
    {
      title: "Fitness Web App",
      projectUrl: {github:'Fitness-App-In-React-Js',Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697985522/Screencast_from_22_%D8%A3%D9%83%D8%AA%D9%88%D8%A8%D8%B1_2023_CET_09_03_54_%D8%B5_fxe2us.webm'},
      imgUrl: Project_Portfilio_2,
      description:{Title:'Fitness Web App',
      Desc:'Developing a web application aimed at helping users access a diverse range of fitness exercises with ease. Through this platform, users can seamlessly explore an extensive library of exercises, each accompanied by a link to a video demonstration, providing clear and concise explanations of the workout routines. Our goal is to make fitness accessible and straightforward, offering a valuable resource for users looking to enhance their workout experience.'
      ,TechUsed:'React js,Materielle Ui ,RapidApi'}
    },
    {
      title: "Weather Application",
      projectUrl: {github:'Wether-App-In-React-Js',
      Deployment:'https://res.cloudinary.com/dctnnjoug/video/upload/v1697991328/Screencast_from_22_%D8%A3%D9%83%D8%AA%D9%88%D8%A8%D8%B1_2023_CET_05_12_17_%D9%85_isrdgs.webm'},
      imgUrl:Project_Portfilio_3,
      description:{Title:'Booking App',
      Desc:'Experience the convenience of our weather application, designed to provide you with up-to-date weather information for any city of your choice. With just a few taps, you can effortlessly select your desired city and instantly retrieve accurate weather status updates. Stay informed, plan your day, and be prepared for any weather conditions with our user-friendly weather app.',
      TechUsed:'React js,RapidApi'}
    },
    
  ];
  export const projects_Athors = [
    {
      title: "Mobile Dshbord",
      projectUrl: {github:'Mobil-Front',Deployment:'#'},
      imgUrl: MobileApp,
      description:{Title:'Mobile Dashbord',
      Desc:'Introducing a straightforward mobile dashboard designed for efficient employee management and attendance tracking. Our mobile dashboard simplifies the task of overseeing your workforce and monitoring their presence.',
      TechUsed:'React Native ,Node Js ,MySql'}
    },

    
  ];

